<script lang="ts">
  import { Button, Input } from "sveltestrap";
  import { Submit } from "../../../../utils/Constant/Constant";
</script>

<Button color="primary" class="m-r-15" type="submit">{Submit}</Button>
<Input class="btn btn-light" type="reset" value="Cancel" />
